import { currentUrl } from '@avensia/excite';
import * as React from 'react';

export const ROOT_KEY = '/';

export const LEVEL_WIDTH = 320;

export type ItemKeyType = string | undefined;
type MainMenuItemType = NordicNest.Api.MenuItemApiModel | null;

export function itemKey(item: MainMenuItemType): ItemKeyType {
  return `${item?.name}-${item?.parentUrl}-${item?.link?.to}`;
}

export function findItem(items: MainMenuItemType[], key: ItemKeyType): MainMenuItemType {
  for (const item of items) {
    if (itemKey(item) === key) {
      return item;
    }

    if (item?.childPages && item.childPages.length > 0) {
      const foundItem = findItem(item.childPages, key);
      if (foundItem) return foundItem;
    }
  }
  return null;
}

export function findParentKey(
  items: MainMenuItemType[],
  visibleKey: ItemKeyType,
  parentKey: ItemKeyType = ROOT_KEY,
): ItemKeyType {
  for (const item of items) {
    const currentKey = itemKey(item);

    if (currentKey === visibleKey) {
      return parentKey;
    }

    if (item?.childPages && item.childPages.length > 0) {
      const key = findParentKey(item.childPages, visibleKey, currentKey);
      if (key) return key;
    }
  }
  return undefined;
}

export function useInitialMenusItemByUrl(
  isOpen: boolean,
): [ItemKeyType, (nextVisibleKey: ItemKeyType) => void, number] {
  const currentUrlPath = currentUrl().pathname;
  const [visibleKey, setVisibleKey] = React.useState<ItemKeyType>(currentUrlPath);
  const initialLevel = currentUrlPath.split('/').length - 1;

  React.useLayoutEffect(() => {
    if (isOpen && visibleKey !== currentUrlPath) {
      setVisibleKey(currentUrlPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const setLevel = React.useCallback(
    (nextVisibleKey: ItemKeyType) => {
      if (visibleKey !== nextVisibleKey) {
        setVisibleKey(nextVisibleKey);
      }
    },
    [visibleKey],
  );
  return [visibleKey ?? ROOT_KEY, setLevel, initialLevel];
}
